import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '../components/Router';
import { handleAPIError, useCognito } from '../utils/Cognito';
import { PARTNER_API } from '../utils/Constants';
import { setPartners } from '../redux/actions/PartnerActions';
import { validPartnerPredicate } from '../utils/ReportsHelpers';

/**
 * A custom React hook for managing partners data and related state.
 * Searches redux store first for partner data, otherwise loads it in.
 * @param {boolean} [validOnly] returns only valid partners (status A or D) false by default.
 * @returns {[Array|null, boolean, string]}
 * An array containing partners data, loading state, and success message.
 */
function usePartners(validOnly = false) {
  const dispatch = useDispatch();
  const cognito = useCognito();
  const router = useRouter();

  const partners = useSelector((state) => state.partner?.partners);

  const [loading, setLoading] = useState(partners === null);

  useEffect(() => {
    function loadPartners() {
      cognito.getPartners().then((res) => {
        if (!handleAPIError(PARTNER_API.GET_PARTNERS, res)) {
          // if not in maintenance then send to error page
          if (res.Result !== 5) router.push('/error');
          return;
        }
        dispatch(setPartners(res));
        setLoading(false);
        if (res.Partners?.length < cognito.getAttribute('custom:partner_identifiers')?.split(',')?.length || 0) cognito.refreshSession().catch(() => {});
      });
    }

    if (partners === null || (partners && partners.length < 1)) {
      loadPartners();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [(validOnly ? partners?.filter(validPartnerPredicate) ?? null :
    partners), loading];
}

export default usePartners;
